export default "__VITE_ASSET__5qhPGlr1__"